var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMileHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5488 2.54492L13.1641 1.19922C13.6211 0.970703 14.1289 0.84375 14.6367 0.84375H16.1094C16.7949 0.84375 17.252 1.5293 17.0234 2.18945C16.5664 3.4082 15.6523 4.42383 14.459 5.0332L7.52734 8.48633C7.42578 8.53711 7.29883 8.5625 7.17188 8.5625H3.66797C3.43945 8.5625 3.21094 8.46094 3.05859 8.2832L1.20508 6.125C1.02734 5.92188 1.10352 5.61719 1.33203 5.49023L2.14453 5.08398C2.37305 4.98242 2.62695 4.98242 2.83008 5.08398L4.32812 5.71875L6.81641 4.44922L3.08398 2.0625C2.83008 1.88477 2.85547 1.47852 3.13477 1.35156L4.30273 0.767578C4.68359 0.564453 5.16602 0.539062 5.59766 0.691406L10.5488 2.54492ZM0.875 11.8125C0.875 11.3809 1.23047 11 1.6875 11H16.3125C16.7441 11 17.125 11.3809 17.125 11.8125C17.125 12.2695 16.7441 12.625 16.3125 12.625H1.6875C1.23047 12.625 0.875 12.2695 0.875 11.8125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileHigh);
export default ForwardRef;